if (!customElements.get('facet-sort-control')) {
  customElements.define(
    'facet-sort-control',
    class FacetSortControl extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.iv-sort-control__trigger');
        this.menu = this.querySelector('.iv-sort-control__menu');
        this.select = this.querySelector('.iv-sort-control__native');
        this.options = [...this.querySelectorAll('.iv-sort-control__option')];

        if (!this.trigger || !this.menu || !this.select || !this.options.length) return;

        this.trigger.addEventListener('click', () => this.toggle());
        this.trigger.addEventListener('keydown', (event) => this.onTriggerKeydown(event));
        this.menu.addEventListener('keydown', (event) => this.onMenuKeydown(event));
        this.options.forEach((option) => {
          option.addEventListener('click', () => this.choose(option));
        });
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };

      onTriggerKeydown(event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.open();
        }
      }

      onMenuKeydown(event) {
        const activeIndex = this.options.indexOf(document.activeElement);
        let nextIndex = activeIndex;

        if (event.key === 'ArrowDown') nextIndex = (activeIndex + 1) % this.options.length;
        else if (event.key === 'ArrowUp')
          nextIndex = (activeIndex - 1 + this.options.length) % this.options.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.options.length - 1;
        else if (event.key === 'Escape') {
          event.preventDefault();
          this.close(true);
          return;
        } else {
          return;
        }

        event.preventDefault();
        this.options[nextIndex].focus();
      }

      toggle() {
        if (this.menu.hidden) this.open();
        else this.close();
      }

      open() {
        this.menu.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        const selected = this.options.find((option) => option.getAttribute('aria-selected') === 'true');
        requestAnimationFrame(() => (selected || this.options[0]).focus());
      }

      close(returnFocus = false) {
        if (!this.menu || this.menu.hidden) return;
        this.menu.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) this.trigger.focus();
      }

      choose(option) {
        const value = option.dataset.value;
        if (!value || this.select.value === value) {
          this.close(true);
          return;
        }

        this.select.value = value;
        this.options.forEach((item) => {
          const selected = item === option;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        this.querySelector('[data-sort-label]').textContent =
          option.querySelector('span')?.textContent?.trim() || option.textContent.trim();
        this.close();
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
      }
    },
  );
}
